import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/companies-controller';
import { MaterialReactTable } from 'material-react-table';

export const CompaniesRoute = () => {
    const { tableSettings } = useController();

    return (
        <OWContainer>
            <MaterialReactTable table={tableSettings} />
        </OWContainer>
    );
};
